require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[61],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(515);


/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Tags = _interopRequireDefault(__webpack_require__(516));

exports["default"] = _Tags["default"];
exports.Tags = _Tags["default"];

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

var _Tags = _interopRequireDefault(__webpack_require__(517));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var tagsClassName = _Tags["default"].tagsClassName.replace(/"/g, '');

var BaPropTypes = _utils.propsUtils.BaPropTypes;

var Tags = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Tags, _Component);

  function Tags() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_optionId", function (index) {
      return "tag_" + index;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_nodeRef", function (node) {
      _this._node = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_listRef", function (node) {
      _this._list = node;
    });
    return _this;
  }

  var _proto = Tags.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        fullWidth = _this$props.fullWidth,
        tags = _this$props.tags,
        children = _this$props.children,
        removable = _this$props.removable,
        disabled = _this$props.disabled,
        editLabel = _this$props.editLabel,
        tagActionIcon = _this$props.tagActionIcon,
        onTagMouseEnter = _this$props.onTagMouseEnter,
        onTagMouseLeave = _this$props.onTagMouseLeave,
        style = _this$props.style;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.classnames)(className, tagsClassName, {
        fullWidth: fullWidth
      }),
      ref: this._nodeRef
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: tagsClassName + "__list",
      ref: this._listRef
    }, tags.map(function (tag) {
      var value = tag.value,
          color = tag.color,
          label = tag.label,
          onClick = tag.onClick;
      var mappedClassName = tagsClassName + "__listItem";

      if ((onClick || editLabel) && !removable) {
        mappedClassName = mappedClassName + " " + tagsClassName + "__actionableOnly";
      }

      if (removable) {
        mappedClassName = mappedClassName + " " + tagsClassName + "__listItem_clickable";
      }

      var mappedOnClick = onClick ? {
        onClick: onClick
      } : {};
      var mappedOnDoubleClick = editLabel ? {
        onDoubleClick: function onDoubleClick(event) {
          return editLabel(tag, event);
        }
      } : {};
      var mappedOnMouseEnter = onTagMouseEnter ? {
        onMouseEnter: function onMouseEnter(event) {
          return onTagMouseEnter(tag, event);
        }
      } : {};
      var mappedOnMouseLeave = onTagMouseLeave ? {
        onMouseLeave: function onMouseLeave(event) {
          return onTagMouseLeave(tag, event);
        }
      } : {};
      var mappedStyle = style ? {
        style: style
      } : {};
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        _react["default"].createElement("span", (0, _extends2["default"])({
          className: mappedClassName,
          key: _this2._optionId(value),
          tabIndex: "0"
        }, mappedOnClick, mappedOnDoubleClick, mappedOnMouseEnter, mappedOnMouseLeave, mappedStyle), /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Tag, {
          filter: removable,
          disabled: disabled,
          type: color,
          id: value,
          onClose: function onClose(e) {
            return tagActionIcon.onClick(e, tag);
          }
        }, label))
      );
    }), children));
  };

  return Tags;
}(_react.Component);

exports["default"] = Tags;
(0, _defineProperty2["default"])(Tags, "propTypes", {
  // common props
  // Provide content to be rendered inside of a node
  children: _propTypes["default"].node,
  // Specify if the is disabled
  disabled: _propTypes["default"].bool,
  // map props
  // Determine if is a filter/chip
  removable: _propTypes["default"].bool,
  // remaining props
  editLabel: _propTypes["default"].func,
  onTagMouseEnter: _propTypes["default"].func,
  onTagMouseLeave: _propTypes["default"].func,
  className: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  tags: _propTypes["default"].array.isRequired,
  tagActionIcon: _propTypes["default"].object,
  style: _propTypes["default"].object,
  // depricated props
  // eslint-disable-next-line react/no-unused-prop-types
  getLocaleString: BaPropTypes.deprecated('is ignored and not applicable to carbon tag'),
  // eslint-disable-next-line react/no-unused-prop-types
  disableTagActionTooltip: BaPropTypes.deprecated('is ignored and not applicable to carbon tag')
});
(0, _defineProperty2["default"])(Tags, "defaultProps", {
  disabled: false,
  getLocaleString: function getLocaleString() {},
  removable: true,
  disableTagActionTooltip: false,
  tagActionIcon: {
    onClick: function onClick() {}
  }
});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(518);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-tags.is-fullWidth{display:block;width:100%}.ba-common-tags__list{display:flex;flex-wrap:wrap;width:100%}.ba-common-tags__list span:focus{outline:none}.ba-common-tags__list span:focus .ba-common-svgIcon{box-shadow:0 0 0 2px #a8c0f3;box-shadow:0 0 0 2px var(--focus, #a8c0f3);-webkit-box-shadow:0 0 0 2px var(--focus, #a8c0f3);-moz-box-shadow:0 0 0 2px var(--focus, #a8c0f3)}[dir=\"ltr\"].ba-common-tags__list button{margin-left:8px}[dir=\"rtl\"].ba-common-tags__list button{margin-left:0;margin-right:8px}[dir=\"ltr\"] .ba-common-tags__list button,.ba-common-tags__list button{margin-left:8px}[dir=\"rtl\"] .ba-common-tags__list button{margin-left:0;margin-right:8px}.ba-common-tags__actionableOnly span{cursor:pointer}.ba-common-tags{transition:opacity .2s ease-in-out}.ba-common-tags>ul .ba-common-svgIcon{fill:#c0bfc0}.ba-common-tags>ul li:hover .ba-common-svgIcon,.ba-common-tags>ul span:focus .ba-common-svgIcon{fill:#0f62fe;fill:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}\n", ""]);

// exports
exports.locals = {
	"tagsClassName": "\"ba-common-tags\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[514,0]]]);
});